// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function … --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeObjectFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useSourceSuggestionKeywordsVariation = makeObjectFlagValueHook('source-suggestion-keywords');
//# sourceMappingURL=useSourceSuggestionKeywordsVariation.js.map